import IMAGES from '@/public/assets/img';

const GlobalBuyerData = {
    posts: [
      {
        id:1,
        title: "Boost Cash Flow and Strengthen Business​",
        // title_ES:"Mejora el Flujo de Efectivo con Pagos Inmediatos",
      },
      {
        id:2,
        title: "Build Strong, Long-Lasting Supplier Partnerships​",
        // title_ES:"Relaciones fortalecidas con proveedores",
      },
      {
        id:3,
        title: "Supply Chain Stability",
        // title_ES:"Estabilidad de la cadena de suministro",
      },
      {
        id:4,
        title: "Operational Efficiency",
        // title_ES:"Eficiencia operativa",
      }
    ],
  
    sliderBuyer_EN:[
      {
        id:1,
      image:IMAGES.globalBuyer.benefitsBuyers,
      // BenfitsHeading:'Enhance Cash Flow with Arbitrage Benefits.',
      BenfitsPayments:'Fast Payments : ',
      BenfitsPaymentsDesc:'Suppliers get instant payment post-delivery, enabling quick reinvestment and leveraging arbitrage (taking advantage of price differences across markets)​.',
      BenfitsFinancial:'Lower Financial Strain :',
      BenfitsFinancialDesc:'Invoice discounting improves liquidity, helping suppliers optimize market pricing.',
      },
      {
        id:2,
      image:IMAGES.globalBuyer.relationshipBuyers,
      // BenfitsHeading:'Strengthened Supplier Relationships',
      BenfitsPayments:'Trust and Reliability : ',
      BenfitsPaymentsDesc: 'Buyers using invoice discouting show commitement to suppliers financial well-being, fostering stronger ties',
      BenfitsFinancial:'Better Negotiation Power: : ',
      BenfitsFinancialDesc:'Suppliers with strong cash flow can offer discounts, negotiate better terms, and maintain stable pricing',
      },
      {
        id:3,
      image:IMAGES.globalBuyer.stabilityBuyers,
      // BenfitsHeading:'Supply Chain Stability',
      BenfitsPayments:'Continuity of Supply : ',
      BenfitsPaymentsDesc:'Stable suppiler cash flow prevents disruptions, ensuring timely deliveries',
      BenfitsFinancial:'Reduced Risk of Suppiler Bankruptcy :',
      BenfitsFinancialDesc:'Instant payments reduce insolvency risks, protecting your suppily chain',
      },
      {
        id:4,
      image:IMAGES.globalBuyer.efficiencyBuyers,
      // BenfitsHeading:'Operational Efficiency',
      BenfitsPayments:'Streamlined operations : ',
      BenfitsPaymentsDesc: 'Factoring manages payments, letting suppliers focus on core tasks',
      BenfitsFinancial:'Lower Costs for Suppliers :',
      BenfitsFinancialDesc:'Factoring costs less than loans improving pricing and terms for buyers'
      },
    ],
    sliderBuyer_ES:[
      {
        id:1,
      image:IMAGES.globalBuyer.benefitsBuyers,
      // BenfitsHeading:'Mejora el Flujo de Efectivo con Pagos Inmediatos',
      BenfitsPayments:'Pagos rápidos : ',
      BenfitsPaymentsDesc: 'Los proveedores obtienen pagos instantáneos después de la entrega, lo que permite una rápida reinversión y aprovechamiento del arbitraje (Aprovechando las diferencias de precios entre mercados)​.',
      BenfitsFinancial:'Menor tensión financiera:',
      BenfitsFinancialDesc:'El descuento de facturas mejora la liquidez, ayudando a los proveedores a optimizar los precios de mercado.',
      },
      {
        id:2,
      image:IMAGES.globalBuyer.relationshipBuyersES,
      // BenfitsHeading:'Relaciones fortalecidas con proveedores' ,
      BenfitsPayments:'Confianza y confiabilidad : ',
      BenfitsPaymentsDesc: 'Los compradores que utilizan el descuento de facturas muestran su compromiso con el bienestar financiero de los proveedores, fomentando vínculos más fuertes',
      BenfitsFinancial:'Mayor poder de negociación : ',
      BenfitsFinancialDesc:'Los proveedores con un fuerte flujo de caja pueden ofrecer descuentos, negociar mejores condiciones y mantener precios estables.',
      },
      {
        id:3,
      image:IMAGES.globalBuyer.stabilityBuyers,
      // BenfitsHeading:'Estabilidad de la cadena de suministro',
      BenfitsPayments:'Continuidad del suministro :',
      BenfitsPaymentsDesc: 'El flujo de caja estable del proveedor evita interrupciones y garantiza entregas oportunas',
      BenfitsFinancial:'Riesgo reducido de quiebra del proveedor:',
      BenfitsFinancialDesc:'Los pagos instantáneos reducen los riesgos de insolvencia y protegen su cadena de suministro',
      },
      {
        id:4,
      image:IMAGES.globalBuyer.efficiencyBuyers,
      // BenfitsHeading:'Eficiencia operativa',
      BenfitsPayments:'Operaciones simplificadas:',
      BenfitsPaymentsDesc:'El factoring gestiona los pagos, permitiendo a los proveedores centrarse en las tareas principales',
      BenfitsFinancial:'Costos más bajos para los proveedores:',
      BenfitsFinancialDesc:'El factoring cuesta menos que los préstamos, lo que mejora los precios y las condiciones para los compradores',
      },
    ],
    sections: [
      {
        title: "Benefits for Buyer",
        backgroundColor: "bg-yellow-100",
        items: [
          {
            icon: IMAGES?.globalBuyer?.checkboxBuyers,
            title: "Support your Suppliers",
            description: "Strengthen relationships by securing required capital."
          },
          {
            icon: IMAGES?.globalBuyer?.checkboxBuyers,
            title: "Maintain Control",
            description: "Continue to pay on your terms."
          }
        ]
      },
    ],
    sections2:[
      {
        title: "Benefits for Supplier",
        backgroundColor: "bg-teal-100",
        items: [
          {
            icon: IMAGES?.globalBuyer?.checkboxBuyers,
            title: "Flexible Terms",
            description: "Match payments with business needs."
          },
          {
            icon: IMAGES?.globalBuyer?.checkboxBuyers,
            title: "No More Chasing Payments",
            description: "Let Credlix manage the collection process."
          },
          {
            icon: IMAGES?.globalBuyer?.checkboxBuyers,
            title: "Immediate Payment",
            description: "Access cash as soon as you issue an invoice."
          }
        ]
      }
    ],

    solutionsSec:{
        heading:'Transform Your Cash Flow with Credlix',
        heading_ES:'Transforma tu flujo de efectivo con Credlix',
        solutions:[
            {heading:'Export Factoring',paragraph:'Access non-recourse factoring for up to 90% of invoice value in 90+ countries, for up to 120 days.',src:IMAGES.globalBuyer.exportBuyer, href: '/export-factoring' },
            {heading:'Supply Chain Financing',paragraph:'Strengthen supplier relationships with timely financing.',src:IMAGES.globalBuyer.financeBuyer, href: '/export-factoring/purchase-order-financing'},
            {heading:'Collateral-Free Payments',paragraph:'Get funded up to $5M instantly, without collateral.',src:IMAGES.globalBuyer.paymentBuyer, href: '/export-factoring/invoice-discounting-platform'},
        ],
        solutions_ES:[
          {heading:'Factoraje de Exportación',paragraph:'Accede a factoraje sin recurso por hasta el 90% del valor de tu factura en más de 90 países, por hasta 120 días.',src:IMAGES.globalBuyer.exportBuyer, href: '/export-factoring/invoice-discounting-platform' },
          {heading:'Financiamiento de la cadena de suministro:',paragraph:'Fortalece las relaciones con los proveedores con financiamiento oportuno.',src:IMAGES.globalBuyer.financeBuyer, href: '/es'},
          {heading:'Pagos inmediatos y sin garantías:',paragraph:'Obtén fondos de hasta $5M al instante, sin garantías.',src:IMAGES.globalBuyer.paymentBuyer, href: '/export-factoring/invoice-discounting-platform'},
      ]
    
    },
    
      "steps": [
        {
          "number": "01",
          "title": "Login Credentials",
          "details": ["Email", "Password"]
        },
        {
          "number": "02",
          "title": "Select Supplier from Drop down list",
          "details": ["Supplier list has to be uploaded on the portal."]
        },
        {
          "number": "03",
          "title": "Details Entry",
          "details": ["Invoice No.", "Invoice Value", "Invoice Amount", "Funding Amount"]
        },
        {
          "number": "04",
          "title": "Payment Terms",
          "details": ["1. Payment term as per Invoice", "2. Requested Payment term"]
        },
        {
          "number": "05",
          "title": "Invoice Upload",
          "details": ["Digital copy of Invoice need to be uploaded"]
        },
        {
          "number": "06",
          "title": "Submit for Payment",
          "details": []
        }
      ],
      // "centerTitle": "Buyer Payment Request Steps",
      // "centerSubtitle": "Fast & Easy"
    
    
    Faq_heading_en:'FAQs', 
    Faq_heading_es: "Preguntas Frecuentes (FAQ's)",
    Home_Faq_en:[
        {   id:0,
          Q:"What is invoice discounting or factoring?​",
          A:"Suppliers get early payment on invoices through a factoring company. The company pays a percentage upfront, and buyers repay them on the due date.​"
        },
        {   id:1,
          Q:"How does invoice discounting benefit me as a buyer?​",
          A:"It helps suppliers with cash flow, strengthening relationships, reducing supply chain risks, and potentially improving terms and pricing.​",
        },
        {   id:2,
          Q:"What is the cost of invoice discounting for buyers?​",
          A:"There’s a fee charged by the factoring company, usually a small percentage of the invoice. Costs vary by company and terms.​",
        },
        {   id:3,
          Q:"How does invoice discounting affect my cash flow?​",
          A:"It doesn’t impact your cash flow directly. You pay the factoring company on the due date, which helps stabilize your supply chain.​",
        },
        {   id:4,
          Q:"Will invoice discounting affect my relationship with suppliers?​",
          A:"It can improve relationships by supporting supplier stability, leading to better partnerships and negotiation terms.​"
        },
        {   id:5,
          Q:"How do I get started with invoice discounting for my suppliers?​",
          A:"Contact a factoring company to discuss options and set up an agreement.​",
        },
        {   id:6,
          Q:"Are there any risks involved in invoice discounting?​",
          A:"The main risk is potential impacts on customer relations due to payment collection management. Many companies offer discreet services to handle this.​",
        },
        {   id:7,
          Q:"Can I choose which invoices to discount?​",
          A:"Yes, you can select which invoices to discount based on your needs and agreements.​"
        },
        {
          id:8,
          Q:"How will invoice discounting impact my financial statements?​",
          A:"It appears as a liability or expense in your financial statements, but doesn’t affect revenue directly.​"
        },
        {
          id:9,
          Q:"Can invoice discounting be used for all suppliers?",
          A:"Yes, as long as suppliers agree and the factoring company accepts the invoices.​"
        },
  ],

    "country_Name": [
        {
          id:1,
          name:"Andorra",
          name_ES:"Andorra",
          code:"376",
        },{
          id:2,
          name:"Aruba",
          name_ES:"Aruba",
          code:"297",
        },{
          id:3,
          name:"Australia",
          name_ES:"Australia",
          code:"61",
        },{
          id:4,
          name:"Austria",
          name_ES:"Austria",
          code:"43",
        },{
          id:5,
          name:"Belgium",
          name_ES:"Bélgica",
          code:"32",
        }, {
          id:6,
          name:"Botswana",
          name_ES:"Botsuana",
          code:"267",
        }, {
          id:7,
          name:"Brazil",
          name_ES:"Brasil",
          code:"55",
        }, {
          id:8,
          name:"Bulgaria",
          name_ES:"Bulgaria",
          code:"359",
        }, {
          id:9,
          name:"Canada",
          name_ES:"Canadá",
          code:"1",
        }, {
          id:10,
          name:"Chile",
          name_ES:"Chile",
          code:"56",
        },{
          id:11,
          name:"China",
          name_ES:"China",
          code:"86",
        },{
          id:12,
          name:"Croatia",
          name_ES:"Croacia",
          code:"385",
        },{
          id:13,
          name:"Cyprus",
          name_ES:"Chipre",
          code:"357",
        },{
          id:14,
          name:"Czech Republic",
          name_ES:"República Checa",
          code:"420",
        },{
          id:15,
          name:"Denmark",
          name_ES:"Dinamarca",
          code:"45",
        }, {
          id:16,
          name:"Estonia",
          name_ES:"Estonia",
          code:"372",
        }, {
          id:17,
          name:"Finland",
          name_ES:"Finlandia",
          code:"358",
        }, {
          id:18,
          name:"France",
          name_ES:"Francia",
          code:"33",
        }, {
          id:19,
          name:"Germany",
          name_ES:"Alemania",
          code:"49",
        }, {
          id:20,
          name:"Greece",
          name_ES:"Grecia",
          code:"30",
        },{
          id:21,
          name:"Hungary",
          name_ES:"Hungría",
          code:"36",
        },{
          id:22,
          name:"Iceland",
          name_ES:"Islandia",
          code:"354",
        },{
          id:23,
          name:"India",
          name_ES:"India",
          code:"91",
        },{
          id:24,
          name:"Indonesia",
          name_ES:"Indonesia",
          code:"62",
        },{
          id:25,
          name:"Ireland",
          name_ES:"Irlanda",
          code:"353",
        }, {
          id:26,
          name:"Israel",
          name_ES:"Israel",
          code:"972",
        }, {
          id:27,
          name:"Italy",
          name_ES:"Italia",
          code:"39",
        }, {
          id:28,
          name:"Japan",
          name_ES:"Japón",
          code:"81",
        }, {
          id:29,
          name:"Kazakhstan",
          name_ES:"Kazajistán",
          code:"7",
        }, {
          id:30,
          name:"Kuwait",
          name_ES:"Kuwait",
          code:"965",
        },{
          id:31,
          name:"Latvia",
          name_ES:"Letonia",
          code:"371",
        },{
          id:32,
          name:"Lithuania",
          name_ES:"Lituania",
          code:"370",
        },{
          id:33,
          name:"Luxembourg",
          name_ES:"Luxemburgo",
          code:"352",
        },{
          id:34,
          name:"Malaysia",
          name_ES:"Malasia",
          code:"60",
        },{
          id:35,
          name:"Malta",
          name_ES:"Malta",
          code:"356",
        }, {
          id:36,
          name:"Mauritius",
          name_ES:"Mauricio",
          code:"230",
        }, {
          id:37,
          name:"Mexico",
          name_ES:"México",
          code:"52",
        }, {
          id:38,
          name:"Montserrat",
          name_ES:"Montserrat",
          code:"1664",
        }, {
          id:39,
          name:"Netherlands",
          name_ES:"Países Bajos",
          code:"31",
        }, {
          id:40,
          name:"New Zealand",
          name_ES:"Nueva Zelanda",
          code:"64",
        },{
          id:41,
          name:"Norway",
          name_ES:"Noruega",
          code:"47",
        },{
          id:42,
          name:"Panama",
          name_ES:"Panamá",
          code:"507",
        },{
          id:43,
          name:"Peru",
          name_ES:"Perú",
          code:"51",
        },{
          id:44,
          name:"Philippines",
          name_ES:"Filipinas",
          code:"63",
        },{
          id:45,
          name:"Poland",
          name_ES:"Polonia",
          code:"48",
        }, {
          id:46,
          name:"Portugal",
          name_ES:"Portugal",
          code:"351",
        }, {
          id:47,
          name:"Qatar",
          name_ES:"Catar",
          code:"974",
        }, {
          id:48,
          name:"Romania",
          name_ES:"Rumania",
          code:"40",
        }, {
          id:49,
          name:"Saint Helena",
          name_ES:"Santa Elena",
          code:"290",
        }, {
          id:50,
          name:"Saudi Arabia",
          name_ES:"Arabia Saudita",
          code:"966",
        },{
          id:51,
          name:"Serbia",
          name_ES:"Serbia",
          code:"381",
        },{
          id:52,
          name:"Singapore",
          name_ES:"Singapur",
          code:"65",
        },{
          id:53,
          name:"Slovakia",
          name_ES:"Eslovaquia",
          code:"421",
        },{
          id:54,
          name:"Slovenia",
          name_ES:"Eslovenia",
          code:"386",
        },{
          id:55,
          name:"South Korea",
          name_ES:"Corea del Sur",
          code:"82",
        }, {
          id:56,
          name:"Spain",
          name_ES:"España",
          code:"34",
        }, {
          id:57,
          name:"Sweden",
          name_ES:"Suecia",
          code:"46",
        }, {
          id:58,
          name:"Switzerland",
          name_ES:"Suiza",
          code:"41",
        }, {
          id:59,
          name:"Taiwan",
          name_ES:"Taiwán",
          code:"886",
        }, {
          id:60,
          name:"Thailand",
          name_ES:"Tailandia",
          code:"66",
        },{
          id:61,
          name:"Trinidad and Tobago",
          name_ES:"Trinidad y Tobag",
          code:"1868",
        },{
          id:62,
          name:"Turks and Caicos Islands",
          name_ES:"Islas Urcas y Caicos",
          code:"1649",
        }, {
          id:63,
          name:"United Arab Emirates", 
          name_ES:"Emiratos Árabes Unidos",
          code:"971",
        }, {
          id:64,
          name:"United Kingdom",
          name_ES:"Reino Unido",
          code:"44",
        }, {
          id:65,
          name:"United States",
          name_ES:"Estados Unidos",
          code:"1",
        }, {
          id:66,
          name:"Uruguay",
          name_ES:"Uruguay",
          code:"598",
        },
      ],
  Home_Faq_es:[
    {   id:0,
      Q:"¿Qué es el descuento de facturas o factoring?​",
      A:"Los proveedores reciben el pago anticipado de facturas a través de una empresa de factoraje. La empresa paga un porcentaje por adelantado y los compradores les reembolsan en la fecha de vencimiento.​"
    },
    {   id:1,
      Q:"¿Cómo me beneficia el descuento de facturas como comprador?​",
      A:"Ayuda a los proveedores con su flujo de efectivo, fortaleciendo las relaciones, reduciendo los riesgos en la cadena de suministro y potencialmente mejorando los términos y precios.​",
    },
    {   id:2,
      Q:"¿Cuál es el costo del descuento de facturas para los compradores?​",
      A:"Hay una tarifa cobrada por la empresa de factoring, generalmente un pequeño porcentaje de la factura. Los costos varían según la empresa y los términos.​",
    },
    {   id:3,
      Q:"¿Cómo afecta el descuento de facturas a mi flujo de efectivo?​",
      A:"No afecta directamente a tu flujo de efectivo. Pagas a la empresa de factoraje en la fecha de vencimiento, lo que ayuda a estabilizar tu cadena de suministro.​",
    },
    {   id:4,
      Q:"¿Afectará el descuento de facturas mi relación con los proveedores?​",
      A:"Puede mejorar las relaciones al apoyar la estabilidad de los proveedores, lo que lleva a mejores asociaciones y términos de negociación.​"
    },
    {   id:5,
      Q:"¿Cómo puedo comenzar con el descuento de facturas para mis proveedores?​",
      A:"Contacta a una empresa de factoraje para discutir las opciones y establecer un acuerdo.​",
    },
    {   id:6,
      Q:"¿Existen riesgos involucrados en el descuento de facturas?​",
      A:"TEl principal riesgo es el impacto potencial en las relaciones con los clientes debido a la gestión del cobro de pagos. Muchas empresas ofrecen servicios discretos para manejar esto.​",
    },
    {   id:7,
      Q:"¿Puedo elegir qué facturas descontar?​",
      A:"Sí, puedes seleccionar qué facturas descontar según tus necesidades y acuerdos.​"
    },
    {
      id:8,
      Q:"¿Cómo afectará el descuento de facturas a mis estados financieros?​",
      A:"Aparece como un pasivo o gasto en tus estados financieros, pero no afecta directamente los ingresos.​"
    },
    {
      id:9,
      Q:"¿Se puede utilizar el descuento de facturas para todos los proveedores?",
      A:"Sí, siempre que los proveedores estén de acuerdo y la empresa de factoring acepte las facturas.​"
    },
],

sections_ES: [
  {
    title: "Beneficios para compradores",
    backgroundColor: "bg-yellow-100",
    items: [
      {
        icon: IMAGES?.globalBuyer?.checkboxBuyers,
        title: "Apoya a tus proveedores",
        description: "Fortalece las relaciones asegurando el capital necesario."
      },
      {
        icon: IMAGES?.globalBuyer?.checkboxBuyers,
        title: "Mantén el control",
        description: "Continúa pagando según tus términos.."
      }
    ]
  },
],
sections2_ES:[
  {
    title: "Beneficios para el proveedor",
    backgroundColor: "bg-teal-100",
    items: [
      {
        icon: IMAGES?.globalBuyer?.checkboxBuyers,
        title: "Términos flexibles",
        description: "Haga coincidir los pagos con las necesidades comerciales."
      },
      {
        icon: IMAGES?.globalBuyer?.checkboxBuyers,
        title: "No más perseguir pagos",
        description: "Deje que Credlix administre el proceso de cobranza."
      },
      {
        icon: IMAGES?.globalBuyer?.checkboxBuyers,
        title: "Pago Inmediato",
        description: "Acceda al efectivo tan pronto como emita una factura."
      }
    ]
  }
],

}

export default GlobalBuyerData;